<!--
 * @Author: 黄悦凯 huangyuekai@jafron.com
 * @Date: 2025-11-26 19:15:39
 * @LastEditors: 黄悦凯 huangyuekai@jafron.com
 * @LastEditTime: 2025-12-12 11:33:21
 * @FilePath: \to-consumer-h5\src\views\clockIn\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="container">
        <div class="menu">
            <div v-for="(item, index) in menuList" :key="index" :class="['btn', item.active ? 'active' : '']"
                @click="toMenu(item)">
                <span>{{ item.name }}</span>
            </div>
        </div>
        <!-- 
        <div class="card">
            <h3 style="margin-top: 0;font-size: 16px">今日打卡榜（模拟）</h3>
            <p class="muted" style="margin-bottom: 0;">示例数据，后台会按综合评分排序</p>
        </div> -->
        <!-- <router-view></router-view> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            menuList: [{
                name: '我要打卡',
                url: '/clockIn/checkin',
                active: false
            }, {
                name: '我有新闻',
                url: '/clockIn/material',
                active: false
            }]
        };
    },
    methods: {
        toMenu(item) {
            this.menuList.forEach(i => {
                if (item.name == i.name) {
                    this.$set(i, 'active', true)
                } else {
                    this.$set(i, 'active', false)
                }
            });
            this.$router.push(item.url)
        }
    }
};
</script>
<style scoped>
.container {
    height: calc(100vh - 32px);
    background-color: linear-gradient(90deg, rgba(150, 226, 251, 0.2) 0%, rgba(183, 171, 236, 0.2) 100%);
    padding: 16px;
    position: relative;
    background-image: url('../../assets/images/bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.menu {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    gap: 40px;
    bottom: 70px;
}

/* Buttons */
.btn {
    position: relative;
    padding: 0 36px;
    height: 50px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    /* 科技蓝文字 */
    background: #027ffd;
    cursor: pointer;
    text-align: center;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid #fd4eb3;
    border-right: 2px solid #fd4eb3;
}

.active {
    background: #fd4eb3;
    border-bottom: 2px solid #027ffd;
    border-right: 2px solid #027ffd;
}

/* 确保文字在发光层之上 */
.btn span {
    position: relative;
    white-space: nowrap;
    letter-spacing: 2px;
}

.icon {
    width: 2.4rem;
    height: 2.4rem;
}
</style>